import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const roleOptionActions = createEagerSelectActions<RoleOption>('[Role Options]');
